module.exports = __webpack_public_path__ + "static/media/21ECLAC31.a1f6845d.jpg";